module.exports = __webpack_public_path__ + "media/images/flags/AM-3fa08fa15eefc33070a6d8b34b744ed8.svg";